module.exports = __webpack_public_path__ + "static/media/icon_212.5e2f8ca8.svg";